<template>
  <div class="board lobby-area">
    <div class="board__header">
        <h1> {{ title }}</h1>
    </div>
    <div class="lobby-area__header">
    </div>
    <div class="lobby-area__lobby" v-for="lobby in lobbies" :key="lobby.title" v-on:click="selectLobby(lobby)">
        <!-- <font-awesome-icon v-if="lobby.password != ''" icon="lock" size="1x"></font-awesome-icon>
        <font-awesome-icon v-if="lobby.password === ''" icon="lock-open" size="1x"></font-awesome-icon> -->
        <span class="lobby__title">{{ lobby.title }}</span>
        <!-- <span class="lobby-area__trash" v-on:click="deleteLobby(lobby)">
            <font-awesome-icon icon="trash-alt" size="1x"></font-awesome-icon>
        </span> -->
    </div>
  </div>
</template>

<script>
    export default {
        props: ['lobbies'],
        data() {
            return {
                title: 'Codenames'
            }
        },
    methods: {
            selectLobby: function(lobby) {
                this.$emit('setActiveLobby', lobby)
            },
            deleteLobby: function(lobby){
                //TODO
                return {lobby}
            }
        }
    }
</script>

<style lang="stylus">
@require '../../styles/index'
.lobby-area
    &__lobby
        text-align center
        font-size 1.4em
        padding  5px 30px
        border-radius 30px
        &:hover
            box-shadow 0px 0px 4px rgba(0, 0, 0, 0.5)
        &:focus, &:active
            background $color__background-board-top--default
            box-shadow 0px 0px 6px rgba(0, 0, 0, 0.5)
            .dark-theme &
                background $color__background-board-top--dark-theme
    &__trash
        float right
        &:hover
            color $color__red
.lobby
    &__title
        padding 0 5px
        width 100%
</style>